import { MiteneLogo } from 'components/atoms/icons'
import { FC } from 'react'

export const AppHeader: FC = () => {
  return (
    <header className='sticky top-0 bg-mi-bg-surface-primary'>
      <div className='text-center p-4'>
        <MiteneLogo size={36} />
      </div>
    </header>
  )
}
